import React from 'react';

const TwilioLogo = props => (
  <svg width={32} height={32} {...props}>
    <path
      d="M16 0C7.147 0 0 7.147 0 16s7.147 16 16 16 16-7.147 16-16S24.853 0 16 0zm0 27.733A11.7 11.7 0 0 1 4.267 16 11.7 11.7 0 0 1 16 4.267 11.7 11.7 0 0 1 27.733 16 11.7 11.7 0 0 1 16 27.733zm7.253-15.68a3.323 3.323 0 0 1-3.306 3.307 3.323 3.323 0 0 1-3.307-3.307 3.323 3.323 0 0 1 3.307-3.306 3.323 3.323 0 0 1 3.306 3.306zm0 7.894a3.323 3.323 0 0 1-3.306 3.306 3.323 3.323 0 0 1-3.307-3.306 3.323 3.323 0 0 1 3.307-3.307 3.323 3.323 0 0 1 3.306 3.307zm-7.893 0a3.323 3.323 0 0 1-3.307 3.306 3.323 3.323 0 0 1-3.306-3.306 3.323 3.323 0 0 1 3.306-3.307 3.323 3.323 0 0 1 3.307 3.307zm0-7.894a3.323 3.323 0 0 1-3.307 3.307 3.323 3.323 0 0 1-3.306-3.307 3.323 3.323 0 0 1 3.306-3.306 3.323 3.323 0 0 1 3.307 3.306z"
      fill="#F22F46"
    />
  </svg>
);

export default TwilioLogo;



// WEBPACK FOOTER //
// ./src/javascripts/app/Webhooks/templates/logos/TwilioLogo.es6.js